import DataTable from "app/components/DataTable";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { HydraulicWallRow } from "../../types";
import { useStyles } from "./styles";

type Props = {
  rows: HydraulicWallRow[];
  loading?: boolean;
};

const HydraulicWallTable = ({ rows, loading = false }: Props) => {
  const { t } = useTranslation();
  const styles = useStyles();

  const columns = useMemo(
    () => [
      {
        id: "hydraulicTypeId",
        label: t("HYDRAULIC_WALL.TABLE.NUMBER"),
        align: "right",
        width: "56px",
        minWidth: "56px",
        format: (row: HydraulicWallRow) => (
          <span className={styles.numberCell}>{row.hydraulicTypeId}</span>
        ),
      },
      {
        id: "hydraulicTypeName",
        label: t("HYDRAULIC_WALL.TABLE.DESCRIPTION"),
        align: "right",
        format: (row: HydraulicWallRow) => (
          <span className={styles.textCell}>{row.hydraulicTypeName}</span>
        ),
      },
    ],
    [styles, t]
  );

  return (
    <div className={styles.root} dir="rtl">
      <DataTable
        rows={rows}
        columns={columns}
        scrollClass="custom-scroll-bar"
        loading={loading && rows.length === 0}
        serialEnabled={false}
        noDataLabel={t("HYDRAULIC_WALL.EMPTY")}
      />
    </div>
  );
};

export default HydraulicWallTable;
